import { CampaignDayBudgetParams, DayBudgetValue } from '../typings/budget';
import { CellKeyFieldsPartial } from '../typings/common';

export const UPDATE_CAMPAIGN_DAY_BUDGET_INFO_REMOTE =
    'UPDATE_CAMPAIGN_DAY_BUDGET_INFO_REMOTE';
export type UPDATE_CAMPAIGN_DAY_BUDGET_INFO_REMOTE = typeof UPDATE_CAMPAIGN_DAY_BUDGET_INFO_REMOTE;

export interface UpdateCampaignDayBudgetInfoRemoteAction {
    type: UPDATE_CAMPAIGN_DAY_BUDGET_INFO_REMOTE;
    params: CampaignDayBudgetParams;
    login: string;
    cellKeyPartial: CellKeyFieldsPartial;
}

export function updateCampaignDayBudgetInfoRemote(
    params: CampaignDayBudgetParams,
    login: string,
    columnName?: string
): UpdateCampaignDayBudgetInfoRemoteAction {
    return {
        type: UPDATE_CAMPAIGN_DAY_BUDGET_INFO_REMOTE,
        params,
        login,
        cellKeyPartial: {
            id: params.campaignId,
            column: columnName
        }
    };
}

export const UPDATE_CAMPAIGN_DAY_BUDGET_INFO =
    'UPDATE_CAMPAIGN_DAY_BUDGET_INFO';
export type UPDATE_CAMPAIGN_DAY_BUDGET_INFO = typeof UPDATE_CAMPAIGN_DAY_BUDGET_INFO;

export interface UpdateCampaignDayBudget {
    type: UPDATE_CAMPAIGN_DAY_BUDGET_INFO;
    campaignId: string;
    value?: DayBudgetValue;
}

export function onUpdateCampaignDayBudgetInfo(
    params: CampaignDayBudgetParams
): UpdateCampaignDayBudget {
    const { campaignId, value } = params;

    return {
        type: UPDATE_CAMPAIGN_DAY_BUDGET_INFO,
        campaignId,
        value
    };
}

export type CampaignGridAction =
    | UpdateCampaignDayBudget
    | UpdateCampaignDayBudgetInfoRemoteAction;
